// import * as dotenv from "dotenv";

// dotenv.config();

export const merchantInfo ={
  accountID: "sothea53@aclb",
  merchantName: "53 Cloud",
  merchantID: "sothea53@aclb",
  acquiringBank: "",
  currency: "USD",
  merchantCity: "Phnom Penh",
  additionalData: {
      mobileNumber: "85585259900",
      billNumber: "INV-2022-12-25",
      storeLabel: "53 Cloud",
      terminalLabel: "012345",
      purposeOfTransaction: "Payment"
  },
  languageData: {
      languagePreference: "km",
      merchantNameAlternateLanguage: "សុធា សាក់",
  },
  upiMerchantAccount: ""
} as const;


export const BASEURL_API_BAKONG= process.env.REACT_APP_BASEURL_API_BAKONG || 'https://api-bakong.nbc.gov.kh/v1';
export const TOKEN_BAKONG = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImlkIjoiMTc0MGU5NzE1YzkyNDQ2OSJ9LCJpYXQiOjE3NDQxNjE4NTAsImV4cCI6MTc1MTkzNzg1MH0.JxSiaRKER31Vsgrh5FQ9qkTATl8ZWy7BQXushSnoEA8';
export const BASEURL_API_WEBSOCKET = 'https://payment53-api-prod.53cloudsite.click'; //TEST
export const CLOUDFLARE_SITEKEY = "0x4AAAAAACBLM_V-QCb7qhnx"; //process.env.REACT_APP_CLOUDFLARE_SITEKEY || 
export const LIMIT_AMOUNT = parseFloat('0.1'); //process.env.REACT_APP_LIMITE_AMOUNT || 
